<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row no-gutters>
            <v-col cols="3">Filtri</v-col>
            <v-col cols="8" class="text--secondary">
              <span  v-if="open" key="0">Imposta i filtri di visualizzazione</span>
              <span v-else key="1">
                {{ startFormatted }} -  {{ endFormatted }} <v-chip class="mr-1" v-for="x in unionFiltri" :key="x">{{ x }}</v-chip> {{ filtro.riferimento }}
              </span>
            </v-col>
            <v-col cols="1" v-if="open"><v-btn @click.stop="onFiltra">Ricerca</v-btn></v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row align="center" justify="space-around" dense>
          <v-col>
            <v-menu
              v-model="menuStart"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedStartFormatted"
                  label="Dalla data"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  hide-details
                  @click:clear="filtro.start = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filtro.start" no-title scrollable @input="menuStart = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-menu
              v-model="menuEnd"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedEndFormatted"
                  label="Alla data"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  hide-details
                  @click:clear="filtro.end = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filtro.end" no-title scrollable @input="menuEnd = false"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row align="center" justify="space-around" dense>
          <v-col>
            <v-select v-model="filtro.causale" :items="causali" dense chips small-chips flat outlined multiple label="Causale" item-text="descrizione" item-value="codice" clearable hide-details></v-select>
          </v-col>
          <v-col>
            <!-- <v-select v-model="filtro.nominativo" :items="clienti" dense chips small-chips flat outlined multiple label="Nominativo" item-text="ragioneSociale" item-value="codice" clearable></v-select> -->
            <v-autocomplete
              v-model="filtroClifor"
              :loading="loading"
              :items="itemsClifor"
              :search-input.sync="searchClifor"
              cache-items
              no-data-text="Cerca un nominativo per codice o descrizione"
              dense chips small-chips flat outlined multiple
              label="Nominativo"
              item-text="testo"
              item-value="id"
              clearable
              :return-object="true"
              hide-details
              @click="value=''"
              >
            </v-autocomplete>
        
        </v-col>
        </v-row>
        <v-row align="center" justify="space-around" dense>
          <v-col>
            <v-select v-model="filtro.tipoRiferimento" :items="tipiRiferimento" dense chips small-chips flat outlined multiple label="Tipo riferimento" item-text="descrizione" item-value="codice" clearable hide-details></v-select>
          </v-col>
          <v-col>
            <v-select v-model="filtro.magazzino" :items="magazzini" dense chips small-chips flat outlined multiple label="Magazzino" item-text="descrizione" item-value="codice" clearable hide-details></v-select>
        </v-col>
        </v-row>
        <v-row align="center" justify="space-around" dense>
          <v-col>
            <v-text-field v-model="filtro.riferimento" dense outlined label="Riferimento" clearable hide-details></v-text-field>
          </v-col>
          <v-col>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import _ from 'lodash'
  import configurazioni from '@/services/configurazioniService.js'
  import clienti from '@/services/clientiService.js'

  export default {
    data: (vm) => ({
      causali: [],
      clienti: [],
      magazzini: [],
      tipiRiferimento: [],
      startFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      endFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      filtro: {
        start: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        end: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        nominativo: [],
        causale: [],
        magazzino: [],
        tipoRiferimento: [],
        riferimento: ''
      },
      menuStart: false,
      menuEnd: false,
      modal: false,
      loading: false,
      itemsClifor: [],
      debounceSearch: null,
      searchClifor: '',
      filtroClifor: []
    }),
    created() {
      this.debounceSearch = _.debounce(this.searchCliforDeb, 500)
    },
    async mounted() {
      this.$emit('ricerca', this.filtro)
      this.causali = await this.getValues('magazzino_causali.causali')
      this.magazzini = await this.getValues('magazzino_magazzini.magazzini')
      this.tipiRiferimento = await this.getValues('magazzino_tipi_movimento.tipiRiferimento')
/*       const data = await clienti.getFilteredCustomers(null, null)
      this.clienti = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : [] */
    },
    computed: {
      unionFiltri() {
        return this.filtro.causale.concat(this.filtroClifor.map(x => x.testo)).concat(this.filtro.tipoRiferimento).concat(this.filtro.magazzino)
      },
      computedStartFormatted () {
        return this.formatDate(this.filtro.start)
      },
      computedEndFormatted () {
        return this.formatDate(this.filtro.end)
      }
    },
    watch: {
      'filtro.start' (val) {
        this.startFormatted = this.formatDate(this.filtro.start)
      },
      'filtro.end' (val) {
        this.endFormatted = this.formatDate(this.filtro.end)
      },
      async searchClifor(val) {
        if (val) {
          await this.debounceSearch(val)
        }
      }      
    },
    methods: {
      onFiltra() {
        this.filtro.nominativo = this.filtroClifor.map( x => x.id)
        this.$emit('ricerca', this.filtro)
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      async getValues(source) {
        let elementi = []
        if (typeof source === 'string') {
          const config = source.split('.')
          const configId = config[0]
          const subId = config[1] || '' // TODO verificare
          const sub2 = config[2] || ''
          const sourceArray = await configurazioni.getConfigurazione(configId, subId)
          if (sub2) {
            elementi = sourceArray ? sourceArray.filter(x => x.tipo === sub2).map(x => { return { codice: x.codice, descrizione: x.descrizione } }) : []
          } else {
            elementi = sourceArray ? sourceArray.map(x => { return { codice: x.codice, descrizione: x.descrizione } }) : []
          }
        } else if (Array.isArray(source)) {
          elementi = [...source]
        }
        return elementi
      },
      async searchCliforDeb(val) {
        if (val) {
          await this.querySelections(val)
        }
      },
      async querySelections (val) {
        this.loading = true
        const filtri = {
          testo: val,
          isCliente: true,
          isFornitore: true
        }
        const data = await clienti.getFilteredCustomers(filtri, null, 'v3')
        const cp = data && data.total_rows > 0 ? data.rows : []
        this.itemsClifor = cp.map(x => {
          return { 
            testo: x.ragioneSociale,
            id: x._id
          }
        })
        this.loading = false
      }
    }
  }
</script>
